import type { GetFacesParams } from '@vlabs/api/luna-api/model';
import { createGenericFiltersContext } from '@vlabs/monokit/shared/lib';

const [
  useListFacesPageFilters,
  ListFacesPageFiltersProvider,
] = createGenericFiltersContext<GetFacesParams>({
  displayName: 'ListFacesPageFilters',
});

export {
  useListFacesPageFilters,
  ListFacesPageFiltersProvider,
};
